import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import { useAuth } from "../../context/AuthContext";
import Cart from "../Cart/Cart";

const Header = ({ location, onOpenLocationModal, menuPage, showLocation }) => {
  const [showCart, setShowCart] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const { cart } = useCart();
  const { user, logout, setStep } = useAuth();
  const navigate = useNavigate();
  const isHomePage = window.location.pathname === "/";

  useEffect(() => {
    if (!menuPage) {
      setShowCart(false);
    }
  }, [menuPage]);

  return (
    <>
      <header className="sticky top-0 z-50 bg-white shadow-md hidden md:block">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              {!showLocation && (
                <button
                  onClick={() => window.history.back()}
                  className="p-1 hover:bg-gray-100 rounded-full transition"
                >
                  <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
              )}
              <h1
                className="text-2xl md:text-3xl font-bold cursor-pointer"
                style={{ color: "#0B9444" }}
                onClick={() => navigate("/")}
              >
                GutfulGoodness
              </h1>
            </div>

            <div className="flex items-center gap-3">


              {/* Menu Button */}
              <button
                onClick={() => setShowMenu(!showMenu)}
                className="p-2 hover:bg-gray-100 rounded-full transition"
                aria-label="Menu"
              >
                <svg
                  className="w-6 h-6"
                  style={{ color: "#0B9444" }}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Location Display */}
          {location && showLocation && (
            <div className="flex items-center gap-2 mt-3 text-sm text-gray-600">
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              <span className="truncate max-w-[200px]">
                {location.address || "Current Location"}
              </span>
              <button
                onClick={onOpenLocationModal}
                className="text-xs font-semibold underline hover:text-green-600 ml-1"
                style={{ color: "#0B9444" }}
              >
                Change
              </button>
            </div>
          )}
        </div>

        {/* Mobile Menu Dropdown */}
        {showMenu && (
          <div className="border-t bg-white w-full absolute shadow-lg">
            <div className="max-w-6xl mx-auto px-4 py-4 space-y-2">
              <button
                onClick={() => {
                  navigate("/");
                  setShowMenu(false);
                }}
                className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition"
              >
                Home
              </button>
              <button
                onClick={() => {
                  navigate("/subscription");
                  setShowMenu(false);
                }}
                className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition"
              >
                Subscriptions
              </button>
              <button
                onClick={() => {
                  navigate("/my-orders");
                  setShowMenu(false);
                }}
                className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition"
              >
                My Orders
              </button>
              <button
                onClick={() => {
                  navigate("/profile");
                  setShowMenu(false);
                }}
                className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition"
              >
                Profile
              </button>
              {user ? (
                <div className="border-t pt-2">
                  <div className="px-4 py-2 text-sm text-gray-600">
                    {(user.phone && `+91 ${user.phone}`) || (user.email && user.email)}
                  </div>
                  <button
                    onClick={() => {
                      logout();
                      setShowMenu(false);
                      window.location.reload();
                    }}
                    className="w-full text-left px-4 py-3 text-red-600 hover:bg-red-50 rounded-lg transition"
                  >
                    Logout
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => setStep("email")}
                  className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition"
                >
                  Login
                </button>
              )}
            </div>
          </div>
        )}
      </header>

      {/* Floating Cart Button */}
      {cart?.length > 0 && menuPage &&
        <button
          onClick={() => setShowCart(true)}
          className="fixed right-6 z-50 p-4 bg-white shadow-xl rounded-full hover:scale-105 transition-transform duration-200 border border-gray-100"
          style={{
            bottom: isHomePage ? "4.5rem" : "1.5rem",
            color: "#0B9444"
          }}
          aria-label="Shopping cart"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
          {cart.length > 0 && (
            <span
              className="absolute -top-1 -right-1 w-6 h-6 rounded-full text-white text-xs flex items-center justify-center font-bold shadow-sm"
              style={{ backgroundColor: "#0B9444" }}
            >
              {cart.length}
            </span>
          )}
        </button>
      }

      {/* Cart Sidebar */}
      {showCart && <Cart onClose={() => setShowCart(false)} location={location} />}
    </>
  );
};

export default Header;
